<div *ngIf="!!fields.length" class="eidos-light-form-wrapper w-100 d-flex flex-column"
  [ngClass]="fullHeight ? 'h-100 ' + wrapperClass : wrapperClass">
  <h3 *ngIf="!!title">{{ title }}</h3>
  <dx-scroll-view *ngIf="!!scrollable && !oneLineForm; else lightFormTemplate" [scrollByThumb]="true" [showScrollbar]="showScrollbar">
    <ng-container [ngTemplateOutlet]="lightFormTemplate"> </ng-container>
  </dx-scroll-view>
</div>
<div *ngIf="!fields.length" class="eidos-light-form-wrapper d-flex justify-content-between">
  <h3 *ngIf="!!title">{{ title }}</h3>
</div>

<ng-template #filtersTemplate let-fields="fields">
  <div *ngFor="let f of fields"
    [class]="compactMode ? 'compact-mode': ''"
    [ngClass]="!isFieldRendered(f) ? 'd-none' : singleFieldWidth ? f.width || 'col-3' : 'col'">

    <div *ngIf="isFieldRendered(f)"
      class="dx-field ms-0"
      [ngClass]="{'flex-row': f.horizontalLabel,'compact-mode': compactMode }">

      <div *ngIf="!f.hideLabel"
        class="dx-field-label"
        [ngClass]="{'compact-mode': compactMode }">

        <content *ngIf="f.htmlCaption; else plainTextCaptionTemplate" [innerHTML]="getHtmlCaption(f)"></content>
        <ng-template #plainTextCaptionTemplate>
          <div class="d-flex align-items-center">
            <span>{{ f.caption ?? parseFieldLabel(f.field) | uppercase }}{{ checkIfFieldIsRequired(f) ? ' *' : ''}}</span>
            <ng-container *ngFor="let btnConfig of getButtonConfigs(f)">
              <eidos-button *ngIf="isButtonVisible(btnConfig)"
                class="ms-2"
                [text]="btnConfig.text"
                [title]="btnConfig.title ?? ''"
                [isDisabled]="isButtonDisabled(btnConfig)"
                (btnClick)="$event.preventDefault(); btnConfig.onClick()"
                stylingMode="contained">
              </eidos-button>
            </ng-container>
          </div>
        </ng-template>

        <ng-container *ngIf="f.popoverMessage && !(f.popoverMessageHidden && f.popoverMessageHidden())">
          <i [tooltipDrawer]="f.popoverMessage" [trigger]="f.popoverMessageMode ?? 'hover'"
            class="fa-solid fa-circle-info popover-message-icon mx-1"></i>
        </ng-container>
      </div>

      <div [ngSwitch]="f.type?.toLowerCase()"class="w-100">

        <div *ngSwitchCase="EidosLightFormFieldType.Text">
          <dx-text-box [(value)]="formValues[f.field]" [showClearButton]="!!f.showClearButton" [valueChangeEvent]="f.triggerChangeOnKeyUp ? 'keyup blur' : 'change'"
            [disabled]="!f.notDisabled && !!f.readOnly && f.readOnly()" [maxLength]="f.maxLength"
            [readOnly]="f.notDisabled && !!f.readOnly && f.readOnly()" [placeholder]="f.placeholder"
            class="dx-field-value" (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Link">
          <div class="d-flex justify-content-center align-items-baseline">
            <dx-text-box [(value)]="formValues[f.field]" [showClearButton]="!!f.showClearButton" [valueChangeEvent]="f.triggerChangeOnKeyUp ? 'keyup blur' : 'change'"
              [disabled]="!f.notDisabled && !!f.readOnly && f.readOnly(f,formValues)" [maxLength]="f.maxLength"
              [readOnly]="f.notDisabled && !!f.readOnly && f.readOnly(f,formValues)" [placeholder]="f.placeholder"
              class="dx-field-value" (onValueChanged)="onValueChanged(f, $event)">
              <dx-validator [validationGroup]="validationGroupName">
                <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                  [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
            <i class="fas fa-link fa-lg" style="cursor: pointer;" (click)="onClick(f,formValues,fields)"></i>
          </div>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Html">
          <eidos-input-editor [type]="'angularEditor'" [(value)]="formValues[f.field]" [config]="HTMLEditorConfigs[f.field]" [disabled]="!f.notDisabled && !!f.readOnly && f.readOnly()" (valueChange)="onValueChanged(f, $event)"/>

          <!-- uncomment if the eidos-input-editor doesn't work -->
          <!-- <angular-editor [(ngModel)]="formValues[f.field]" [config]="HTMLEditorConfigs[f.field]" (ngModelChange)="onValueChanged(f, $event)">
          </angular-editor> -->
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.HtmlDE">
          <dx-html-editor style="background-color: white;"
           [height]="f.height" [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())" (onValueChanged)="onValueChanged(f, $event)">
            <dxo-toolbar [multiline]="true">
              <dxi-item name="undo"></dxi-item>
              <dxi-item name="redo"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"
                [options]="{ inputAttr: { 'aria-label': 'Font size' } }"></dxi-item>
              <dxi-item name="font" [acceptedValues]="[
                          'Arial',
                          'Tahoma',
                          'Times New Roman',
                          'Verdana'
                        ]" [options]="{ inputAttr: { 'aria-label': 'Font family' } }"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="bold"></dxi-item>
              <dxi-item name="italic"></dxi-item>
              <dxi-item name="strike"></dxi-item>
              <dxi-item name="underline"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="alignLeft"></dxi-item>
              <dxi-item name="alignCenter"></dxi-item>
              <dxi-item name="alignRight"></dxi-item>
              <dxi-item name="alignJustify"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="orderedList"></dxi-item>
              <dxi-item name="bulletList"></dxi-item>
              <dxi-item name="separator"></dxi-item>
              <dxi-item name="link"></dxi-item>
              <dxi-item name="clear"></dxi-item>
              <dxi-item name="separator"></dxi-item>
            </dxo-toolbar>
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
            </dx-validator>
          </dx-html-editor>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Textarea">
          <dx-text-area [(value)]="formValues[f.field]" [disabled]="!f.notDisabled && !!f.readOnly &&  f.readOnly(f,formValues)"
            [readOnly]="f.notDisabled && !!f.readOnly &&  f.readOnly(f,formValues)" [autoResizeEnabled]="!!f.autoResizeEnabled"
            [minHeight]="f.minHeight" class="dx-field-value w-100" [height]="f.height" [placeholder]="f.placeholder ?? ''"
            (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
            </dx-validator>
          </dx-text-area>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Email">
          <dx-text-box [(value)]="formValues[f.field]" [showClearButton]="!!f.showClearButton"
            [disabled]="(!!f.readOnly && f.readOnly())" class="dx-field-value" [placeholder]="f.placeholder ?? ''"
            (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
              <dxi-validation-rule type="email" message="EMAIL is invalid"></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Phone">
          <eidos-input-phone [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())"
            [required]="checkIfFieldIsRequired(f)" [allowPrefix]="!!f.allowPrefix" [placeholder]="f.placeholder ?? ''"
            [requiredMessage]="f.requiredMessage ?? 'Field is required'" [validationGroupName]="validationGroupName"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            (valueChange)="onValueChanged(f, $event)"></eidos-input-phone>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Number">
          <eidos-input-number [min]="f.min" [max]="f.max" [(value)]="formValues[f.field]" [placeholder]="f.placeholder"
            [disabled]="(!!f.readOnly && f.readOnly())" [required]="checkIfFieldIsRequired(f)"
            [showSpinButtons]="!!f.showSpinButtons" [showClearButton]="!!f.showClearButton" [format]="f.format"
            [requiredMessage]="f.requiredMessage ?? 'Field is required'" [validationGroupName]="validationGroupName"
            [triggerChangeOnKeyUp]="f.triggerChangeOnKeyUp"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            (valueChange)="onValueChanged(f, $event)"></eidos-input-number>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Percentage">
          <eidos-input-number [min]="f.min ?? 0" [max]="f.max ?? 100" [(value)]="formValues[f.field]"
            [disabled]="(!!f.readOnly && f.readOnly())" [required]="checkIfFieldIsRequired(f)"
            [showSpinButtons]="!!f.showSpinButtons" [showClearButton]="!!f.showClearButton" [format]="f.format"
            [requiredMessage]="f.requiredMessage ?? 'Field is required'" [validationGroupName]="validationGroupName"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            (valueChange)="onValueChanged(f, $event)" [placeholder]="f.placeholder ?? ''"></eidos-input-number>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Checkbox">
          <eidos-input-checkbox [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly &&  f.readOnly(f,formValues))"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            [defaultValue]="false" (valueChange)="onValueChanged(f, $event)">
          </eidos-input-checkbox>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Select">
          <dx-select-box *ngIf="checkIfStructuredOptions(f)" [showClearButton]="!!f.showClearButton"
            [placeholder]="f.placeholder" [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())"
            [dataSource]="f.options ?? []" valueExpr="value" displayExpr="label"
            (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
          <dx-select-box *ngIf="!checkIfStructuredOptions(f)" [showClearButton]="!!f.showClearButton"
            [placeholder]="f.placeholder" [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())"
            [items]="f.options ?? []" (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Radio">
          <dx-radio-group *ngIf="checkIfStructuredOptions(f)" [(value)]="formValues[f.field]"
            [disabled]="(!!f.readOnly && f.readOnly())" layout="horizontal" [dataSource]="f.options ?? []"
            valueExpr="value" displayExpr="label" (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
            </dx-validator>
          </dx-radio-group>
          <dx-radio-group *ngIf="!checkIfStructuredOptions(f)" [(value)]="formValues[f.field]"
            [disabled]="(!!f.readOnly && f.readOnly())" layout="horizontal" [items]="f.options ?? []"
            (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'"></dxi-validation-rule>
            </dx-validator>
          </dx-radio-group>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Date">
          <eidos-input-datetime [placeholder]="f.placeholder ?? ''" [disabled]="(!!f.readOnly && f.readOnly(f, formValues))"
            [dateValueType]="f.format ?? 'date'" [min]="f.minDate ?? defaultMinDate" [max]="f.maxDate ?? defaultMaxDate"
            [disabledDates]="f.disabledDates ?? []" [showClearButton]="f.showClearButton" [displayFormat]="f.displayFormat"
            [(value)]="formValues[f.field]" (valueChange)="onValueChanged(f, $event)"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            [validationGroupName]="validationGroupName" [required]="checkIfFieldIsRequired(f)"
            [requiredMessage]="f.requiredMessage ?? 'Field is required'">
          </eidos-input-datetime>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.DateTime">
          <dx-date-box [disabled]="(!!f.readOnly && f.readOnly())" [type]="'datetime'" displayFormat="yyyy/MM/dd HH:mm"
            [(value)]="formValues[f.field]" (valueChange)="onValueChanged(f, $event)" >
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'">
              </dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Time">
          <dx-date-box [disabled]="(!!f.readOnly &&  f.readOnly(f,formValues))" [type]="'time'" displayFormat="HH:mm"
            [(value)]="formValues[f.field]" (valueChange)="onValueChanged(f, $event)" [interval]="f.interval ?? 30">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required"
                [message]="f.requiredMessage ?? 'Field is required'">
              </dxi-validation-rule>
            </dx-validator>
          </dx-date-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.DateMonths">
        <dx-tag-box [dataSource]="monthFromList" displayExpr="displayValue" valueExpr="value" [placeholder]="f.placeholder"
          [searchEnabled]="true" [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())"></dx-tag-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.DateMonth">
          <dx-select-box [dataSource]="monthFromList" displayExpr="displayValue" valueExpr="value" [placeholder]="f.placeholder"
            [searchEnabled]="true" [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())" [showClearButton]="f.showClearButton"></dx-select-box>
          </div>

        <div *ngSwitchCase="EidosLightFormFieldType.DateRange">
          <eidos-input-datetimerange layoutDirection="horizontal" [(value)]="formValues[f.field.split(',')[0].trim()]"
            [(otherValue)]="formValues[f.field.split(',')[1].trim()]" [from]="getDateRangeConfig(f, 'from')"
            [to]="getDateRangeConfig(f, 'to')" [min]="f.minDate" [max]="f.maxDate" [showClearButton]="f.showClearButton"
            [required]="checkIfFieldIsRequired(f)" [disabled]="(!!f.readOnly &&  f.readOnly(f,formValues))"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            (valueChange)="onValueChanged(f, $event, f.field.split(',')[0].trim())"
            (otherValueChange)="onValueChanged(f, $event, f.field.split(',')[1].trim())"
            [requiredMessage]="f.requiredMessage ?? 'Field is required'" [validationGroupName]="validationGroupName">
          </eidos-input-datetimerange>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Selectize">
          <eidos-input-selectize *ngIf="f.selectizeInputConfig" class="dx-field-value w-100"
            [loadingMode]="f.selectizeInputConfig.loadingMode" [memoizedEntity]="f.selectizeInputConfig.memoizedEntity"
            [items]="f.selectizeInputConfig.items"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            [api]="f.selectizeInputConfig.api" [asyncItems]="f.selectizeInputConfig.asyncItems"
            [(value)]="formValues[f.field]" [onValueChange]="f.selectizeInputConfig.onValueChange"
            [keyField]="f.selectizeInputConfig.keyField" [valueField]="f.selectizeInputConfig.valueField"
            [minSearchLength]="f.selectizeInputConfig.minSearchLength!"
            [showClearButton]="!!f.selectizeInputConfig.showClearButton"
            [searchFields]="f.selectizeInputConfig.searchField" [maxItems]="f.selectizeInputConfig.maxItems"
            [displayField]="f.selectizeInputConfig.displayField"
            [displayFieldTag]="f.selectizeInputConfig.displayFieldTag"
            [displayFieldTagTooltip]="f.selectizeInputConfig.displayFieldTagTooltip"
            [acceptCustomValue]="f.selectizeInputConfig.acceptCustomValue"
            [customItemCreate]="f.selectizeInputConfig.customItemCreate" [disabled]="(!!f.readOnly && f.readOnly())"
            [required]="checkIfFieldIsRequired(f)" [validationGroupName]="validationGroupName"
            [requiredMessage]="f.requiredMessage ?? 'Field is required'"
            [placeholder]="f.selectizeInputConfig.placeholder ?? ''" [config]="f.selectizeInputConfig"
            [opened]="f.selectizeInputConfig.opened ?? false">
          </eidos-input-selectize>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.PopupListSelector">
          <core-popup-list-selector *ngIf="f.popupListSelectorConfig" class="dx-field-value w-100"
            (onValueChanged)="onValueChanged(f, $event)" [config]="f.popupListSelectorConfig"
            [(value)]="formValues[f.field]">
          </core-popup-list-selector>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Country">
          <dx-select-box [showClearButton]="!!f.showClearButton" [placeholder]="f.placeholder"
            [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())" [dataSource]="countries"
            [searchEnabled]="true" displayExpr="Country" valueExpr="CountryCod"
            (onValueChanged)="onValueChanged(f, $event)">

            <div *dxTemplate="let data of 'item'">
              <div [title]="data.Country">{{ data.Country }}</div>
            </div>

            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required" message="COUNTRY is required">
              </dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.State">
          <dx-select-box [showClearButton]="!!f.showClearButton" [placeholder]="f.placeholder"
            [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly()) || !states.length"
            [dataSource]="states" [searchEnabled]="true" displayExpr="State" valueExpr="StateISOCod"
            (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required" message="STATE is required">
              </dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.County">
          <dx-select-box *ngIf="!!counties.length" [showClearButton]="!!f.showClearButton" [placeholder]="f.placeholder"
            [(value)]="formValues[f.field]" [disabled]="(!!f.readOnly && f.readOnly())" [dataSource]="counties"
            [searchEnabled]="true" displayExpr="County" valueExpr="County" (onValueChanged)="onValueChanged(f, $event)">
            <dx-validator [validationGroup]="validationGroupName">
              <dxi-validation-rule *ngIf="checkIfFieldIsRequired(f)" type="required" message="COUNTY is required">
              </dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
          <dx-text-box *ngIf="!counties.length" [(value)]="formValues[f.field]" [showClearButton]="!!f.showClearButton"
            [maxLength]="f.max" [disabled]="(!!f.readOnly && f.readOnly()) || !formValues.countryCod"
            (onValueChanged)="onValueChanged(f, $event)"></dx-text-box>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.CountryStateCountyAddress">
          <ng-container *ngIf="getCountryStateCountyAddressConfig(f) as cscaConfig">
            <eidos-country-state-county-address
              [values]="formValues"
              [fields]="buildCountryStateCountyAddressFields(cscaConfig)"
              [disabled]="(!!f.readOnly && f.readOnly(f,formValues))"
              [allowZip4]="cscaConfig.allowZip4 ?? false"
              [boolMarket]="cscaConfig.visible?.market ?? false"
              [boolCountry]="cscaConfig.visible?.country ?? true"
              [boolAddressSearch]="cscaConfig.visible?.addressSearch ?? true"
              [boolState]="cscaConfig.visible?.state ?? true"
              [boolCounty]="cscaConfig.visible?.county ?? true"
              [boolAddress]="cscaConfig.visible?.address ?? true"
              [boolCity]="cscaConfig.visible?.city ?? false"
              [boolZip]="cscaConfig.visible?.zip ?? false"
              [boolZip4]="cscaConfig.visible?.zip4 ?? false"
              [requiredMarket]="cscaConfig.required?.market ?? false"
              [requiredCountry]="cscaConfig.required?.country ?? true"
              [requiredState]="cscaConfig.required?.state ?? false"
              [requiredCounty]="cscaConfig.required?.county ?? false"
              [requiredAddress]="cscaConfig.required?.address ?? false"
              [requiredCity]="cscaConfig.required?.city ?? false"
              [requiredZip]="cscaConfig.required?.zip ?? false"
              [requiredZip4]="cscaConfig.required?.zip4 ?? false"
              [labelMarket]="cscaConfig.labels?.market ?? 'Market'"
              [labelCountry]="cscaConfig.labels?.country ?? 'Country'"
              [labelAddress]="cscaConfig.labels?.addressSearch ?? 'Search Address'"
              [labelState]="cscaConfig.labels?.state ?? 'State'"
              [labelCounty]="cscaConfig.labels?.county ?? 'County'"
              [labelAddressInput]="cscaConfig.labels?.address ?? 'Address'"
              [labelCity]="cscaConfig.labels?.city ?? 'City'"
              [labelZip]="cscaConfig.labels?.zip ?? 'Zip'"
              [labelZip4]="cscaConfig.labels?.zip4 ?? 'Zip 4'"
              [colClasses]="cscaConfig.widths ?? {}"
              (valuesChange)="onCountryStateCountyAddressValuesChange(f, $event)">
            </eidos-country-state-county-address>
          </ng-container>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.ServiceType">
          <eidos-input-selectize [items]="serviceTypesSelectizeConfig.items"
            [loadingMode]="serviceTypesSelectizeConfig.loadingMode"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            [memoizedEntity]="serviceTypesSelectizeConfig.memoizedEntity ?? ''"
            [asyncItems]="serviceTypesSelectizeConfig.asyncItems"
            [searchFields]="serviceTypesSelectizeConfig.searchField"
            [displayField]="serviceTypesSelectizeConfig.displayField" [maxItems]="serviceTypesSelectizeConfig.maxItems"
            [disabled]="(!!f.readOnly && f.readOnly())" [checkUnique]="!!serviceTypesSelectizeConfig.checkUnique"
            [minSearchLength]="serviceTypesSelectizeConfig.minSearchLength ?? 0"
            [keyField]="serviceTypesSelectizeConfig.keyField"
            [onValueChange]="serviceTypesSelectizeConfig.onValueChange"
            [showClearButton]="serviceTypesSelectizeConfig.showClearButton ?? false"
            [placeholder]="serviceTypesSelectizeConfig.placeholder" [(value)]="formValues.serviceType">
          </eidos-input-selectize>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Service">
          <eidos-input-selectize [items]="servicesSelectizeConfig.items"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            [loadingMode]="servicesSelectizeConfig.loadingMode" [asyncItems]="servicesSelectizeConfig.asyncItems"
            [memoizedEntity]="servicesSelectizeConfig.memoizedEntity ?? 'cache-service'"
            [searchFields]="servicesSelectizeConfig.searchField" [displayField]="servicesSelectizeConfig.displayField"
            [maxItems]="servicesSelectizeConfig.maxItems"
            [minSearchLength]="servicesSelectizeConfig.minSearchLength ?? 0"
            [keyField]="servicesSelectizeConfig.keyField" [onValueChange]="servicesSelectizeConfig.onValueChange"
            [showClearButton]="servicesSelectizeConfig.showClearButton ?? false"
            [placeholder]="servicesSelectizeConfig.placeholder" [(value)]="formValues.service">
          </eidos-input-selectize>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Option">
          <eidos-input-selectize [items]="optionsSelectizeConfig.items"
            [loadingMode]="optionsSelectizeConfig.loadingMode"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            [memoizedEntity]="optionsSelectizeConfig.memoizedEntity ?? 'cache-option'"
            [asyncItems]="optionsSelectizeConfig.asyncItems"
            [searchFields]="optionsSelectizeConfig.searchField" [displayField]="optionsSelectizeConfig.displayField"
            [maxItems]="optionsSelectizeConfig.maxItems" [disabled]="!!optionsSelectizeConfig.disabled"
            [minSearchLength]="optionsSelectizeConfig.minSearchLength ?? 0" [keyField]="optionsSelectizeConfig.keyField"
            [onValueChange]="optionsSelectizeConfig.onValueChange"
            [showClearButton]="optionsSelectizeConfig.showClearButton ?? false"
            [placeholder]="optionsSelectizeConfig.placeholder" [(value)]="formValues.option"
            [config]="optionsSelectizeConfig">
          </eidos-input-selectize>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.File">
          <eidos-upload-file [multiple]="true" [autoUpload]="false" [(files)]="formValues[f.field]"></eidos-upload-file>
        </div>

        <div *ngSwitchCase="EidosLightFormFieldType.Custom">
          <ng-container *ngIf="f.customTemplate?.()" [ngTemplateOutlet]="f.customTemplate?.()"
            [ngTemplateOutletContext]="{formValues, field: f}"></ng-container>
        </div>
        <div *ngSwitchCase="EidosLightFormFieldType.NumberPopup">
          <eidos-input-number-popup [min]="f.numberPopupConfig.min" [max]="f.numberPopupConfig.max"
            [avoidDoubleChangeEvent]="f.avoidDoubleChangeEvent"
            [elements]="f.numberPopupConfig.elements" [label]="f.numberPopupConfig.label"
            [value]="buildSelectedValues(f.numberPopupConfig.elements)"
            [onValueChange]="f.numberPopupConfig.onValueChange" width="100%" [disabled]="true">
          </eidos-input-number-popup>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #actionButtonsTemplate>

  <div *ngIf="!hideButtons" class="d-flex align-items-end action-buttons--wrapper" [ngClass]="{ 'flex-row-reverse': reverseButtons }">

    <div *ngIf="hasCollapsedFields()" class="res-header-popup-more">
      <dx-button stylingMode="contained" type="normal"
        [text]="moreFieldsExpanded ? lessButtonText : moreButtonText"
        [icon]="moreFieldsExpanded ? lessButtonIcon : moreButtonIcon"
        (click)="$event.preventDefault(); toggleMoreFields()">
      </dx-button>
    </div>

    <div *ngIf="!submitButtonHidden" class="res-header-popup-search" [ngClass]="submitButtonClass"
      [ngStyle]="{ cursor: submitButtonDisabled ? 'not-allowed' : 'pointer' }">
      <dx-button id="eidos-light-form-submit-button" [useSubmitBehavior]="true" stylingMode="contained"
        [text]="submitButtonText" type="normal" [icon]="submitButtonIcon" [disabled]="submitButtonDisabled">
      </dx-button>
    </div>

    <div *ngIf="!createButtonHidden" class="res-header-popup-plus" [ngClass]="createButtonClass || submitButtonClass">
      <dx-button stylingMode="contained" [icon]="createButtonIcon" [text]="createButtonText"
        [disabled]="createButtonDisabled" (click)="onCreateBtnClick.emit()">
      </dx-button>
    </div>

    <div *ngIf="!clearButtonHidden" class="res-header-popup-clear" [ngClass]="clearButtonClass">
      <dx-button stylingMode="contained" icon="fas fa-eraser" (click)="clearForm()"> </dx-button>
    </div>

  </div>

</ng-template>

<ng-template #lightFormTemplate>
  <form (submit)="handleFormSubmit($event)" class="eidos-light-form"
    [ngClass]="{ 'overflow-visible': !scrollable || !!oneLineForm }">
    <div [ngSwitch]="mode">
      <ng-container *ngSwitchCase="'default'">
        <div *ngIf="hasCollapsedFields(); else defaultFormLayout" class="eidos-light-form-more-layout"
          [ngClass]="{'compact-mode': compactMode}">
          <div class="eidos-light-form-one-line" [ngClass]="{'from-wap':formWrap, 'compact-mode': compactMode}">
            <ng-container [ngTemplateOutlet]="filtersTemplate" [ngTemplateOutletContext]="{
                fields: getPrimaryFields()
              }">
            </ng-container>
            <ng-container [ngTemplateOutlet]="actionButtonsTemplate"> </ng-container>
          </div>
          <div *ngIf="moreFieldsExpanded" class="eidos-light-form-one-line"
            [ngClass]="{'from-wap':formWrap, 'compact-mode': compactMode}">
            <ng-container [ngTemplateOutlet]="filtersTemplate" [ngTemplateOutletContext]="{
                fields: getCollapsedFields()
              }">
            </ng-container>
          </div>
        </div>
        <ng-template #defaultFormLayout>
          <div
            [class]="oneLineForm ? 'eidos-light-form-one-line' : singleFieldWidth ? 'row' : 'row ' + colsClasses"
            [ngClass]="{'from-wap':formWrap, 'compact-mode': compactMode}">
            <ng-container [ngTemplateOutlet]="filtersTemplate" [ngTemplateOutletContext]="{
                fields: fields
              }">
            </ng-container>
            <div *ngIf="!oneLineForm && !checkIfAllButtonsAreHidden(); else actionButtonsTemplate"
              class="d-flex justify-content-end pt-2 action-buttons-wrapper"
              [ngClass]="{'col-012':compactMode,'w-100':!compactMode}">
              <ng-container [ngTemplateOutlet]="actionButtonsTemplate"> </ng-container>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <div *ngSwitchCase="'section-accordion'" class="pt-3">
        <dx-accordion *ngIf="!!sections.length" #accordion [dataSource]="sections" [collapsible]="true"
          [multiple]="true" [animationDuration]="300" [selectedItems]="openedSections" id="accordion-container">
          <div *dxTemplate="let s of 'title'">
            <h1>{{ s }}</h1>
          </div>
          <div *dxTemplate="let s of 'item'" class="row" [ngClass]="!singleFieldWidth ? colsClasses : ''">
            <ng-container [ngTemplateOutlet]="filtersTemplate" [ngTemplateOutletContext]="{
                fields: getFieldsBySection(s)
              }">
            </ng-container>
          </div>
        </dx-accordion>
        <div *ngIf="!checkIfAllButtonsAreHidden()" class="d-flex justify-content-end pt-2">
          <ng-container [ngTemplateOutlet]="actionButtonsTemplate"> </ng-container>
        </div>
      </div>
      <div *ngSwitchCase="'section'" class="pt-3">
        <dx-scroll-view [scrollByThumb]="true" [showScrollbar]="showScrollbar">
          <div *ngFor="let s of sections" class="py-4">
            <h3 *ngIf="!isEmptyOrWhiteSpace(s)">{{ s | uppercase }}</h3>
            <div class="row" [ngClass]="!singleFieldWidth ? colsClasses : ''">
              <ng-container [ngTemplateOutlet]="filtersTemplate" [ngTemplateOutletContext]="{
                  fields: getFieldsBySection(s)
                }">
              </ng-container>
            </div>
          </div>
        </dx-scroll-view>

        <div *ngIf="!checkIfAllButtonsAreHidden()" class="d-flex justify-content-end pt-2">
          <ng-container [ngTemplateOutlet]="actionButtonsTemplate"> </ng-container>
        </div>
      </div>
      <div *ngSwitchCase="'section-with-separator'" class="pt-3">
        <dx-scroll-view [scrollByThumb]="true" [showScrollbar]="showScrollbar">
          <div *ngFor="let s of getVisibleSections(); index as i">
            <div *ngIf="i != 0" class="section-separator"></div>
            <div class="row" [ngClass]="!singleFieldWidth ? colsClasses : ''">
              <ng-container [ngTemplateOutlet]="filtersTemplate" [ngTemplateOutletContext]="{
                  fields: getVisibleFieldsBySection(s)
                }">
              </ng-container>
            </div>
          </div>
        </dx-scroll-view>

        <div *ngIf="!checkIfAllButtonsAreHidden()" class="d-flex justify-content-end pt-2">
          <ng-container [ngTemplateOutlet]="actionButtonsTemplate"> </ng-container>
        </div>
      </div>

      <div *ngSwitchCase="'section-with-themed-section-title'">
        <dx-scroll-view [scrollByThumb]="true" [showScrollbar]="showScrollbar">
          <div style="margin-bottom: 8px;" *ngFor="let s of sections; index as i">
            <!-- <div *ngIf="i != 0" class="section-separator"></div> -->
            <h4 style="padding: 5px; color: #d9b57f; background-color: #1f1d1e;" *ngIf="!isEmptyOrWhiteSpace(s)">{{ s | uppercase }}</h4>
            <div class="row" [ngClass]="!singleFieldWidth ? colsClasses : ''">
              <ng-container [ngTemplateOutlet]="filtersTemplate" [ngTemplateOutletContext]="{
                  fields: getFieldsBySection(s)
                }">
              </ng-container>
            </div>
          </div>
        </dx-scroll-view>

        <div *ngIf="!checkIfAllButtonsAreHidden()" class="d-flex justify-content-end pt-2">
          <ng-container [ngTemplateOutlet]="actionButtonsTemplate"> </ng-container>
        </div>
      </div>

    </div>
  </form>
</ng-template>
